/**
 * WhatsApp icon component
 * PURPOSE: Keeps the official-style WhatsApp symbol consistent everywhere.
 *
 * EDIT HERE:
 * - Change `size` where the component is used to make the icon larger or smaller.
 * - The icon inherits its color from CSS through `currentColor`.
 */

import React from 'react';

/**
 * Render an accessible inline SVG without loading an external image or icon library.
 */
export default function WhatsAppIcon({ size = 28, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-hidden="true"
      focusable="false"
    >
      {/* Speech-bubble outline and tail. */}
      <path
        fill="currentColor"
        d="M16.02 3.2A12.77 12.77 0 0 0 5.1 22.58L3.2 29l6.58-1.73a12.78 12.78 0 1 0 6.24-24.07Zm0 23.24a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.9 1.03 1.04-3.8-.25-.39a10.62 10.62 0 1 1 8.9 4.87Z"
      />
      {/* Telephone handset inside the bubble. */}
      <path
        fill="currentColor"
        d="M21.86 18.73c-.32-.16-1.9-.94-2.2-1.05-.29-.11-.5-.16-.71.16-.21.32-.82 1.05-1 1.27-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.25-.62-.52-.54-.71-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.07 1.3 3.28c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.9-.78 2.17-1.53.26-.75.26-1.4.18-1.53-.08-.13-.29-.21-.61-.37Z"
      />
    </svg>
  );
}
